<!--
  This work has been created or enhanced by
    Markus Luckey, 2025, KERNBLICK GmbH

  This file is covered by the EU PL 1.2 license.
  You may obtain a copy of the licence at
  https://joinup.ec.europa.eu/collection/eupl/eupl-text-eupl-12
-->

<template>
  <!--eslint-disable-->
  <div class="auth">
    <h1>{{ $t('authTest') }}</h1>

    <h2>{{ $t('readApps') }}</h2>
    <div class="btn-group">
      <button @click="getApps()" href="#">{{ $t('getApps') }}</button>
    </div>

    <h2>{{ $t('tokenInformation') }}</h2>
    <div class="btn-group">
      <button @click="getToken()" href="#">{{ $t('token') }}</button>
      <button @click="getTokenProfile()" href="#">{{ $t('tokenProfile') }}</button>
      <button @click="getTokenId()" href="#">{{ $t('idToken') }}</button>
      <button @click="getTokenSessionState()" href="#">{{ $t('sessionState') }}</button>
      <button @click="getAccessToken()" href="#">{{ $t('accessToken') }}</button>
      <button @click="getTokenScopes()" href="#">{{ $t('scopes') }}</button>
      <button @click="renewToken()" href="#">{{ $t('forceTokenRenewal') }}</button>
    </div>


    <h1 v-show="apiResponse">{{ $t('api') }}</h1>
    <pre id="resultsApi"></pre>

    <br>

    <h1 v-show="tokenResponse">{{ $t('tokenInfo') }}</h1>
    <pre id="resultsToken"></pre>

  </div>
</template>

<script>
import Mgr from '@/services/SecurityService';
import Api from '@/services/AppService';

export default {
  name: 'Auth',
  data () {
    return {
      mgr: new Mgr(),
      api: Api,
      apiResponse: undefined,
      tokenResponse: undefined,
    }
  },
  created: () => {
    console.log("Created Auth component");
  },
  methods: {
    async getApps(){
      if(!this.apiResponse) {
        this.apiResponse = await this.api.fetchApps()
        this.logApi(this.apiResponse)
      } else {
        this.apiResponse = ""
        this.logApi(this.apiResponse)
      }
    },
    getToken(){
      let self = this
      this.mgr.getUser().then(
        token => {
          self.logToken(token)
        },
        err => {
          console.log(err)
      })
    },
    getTokenId(){
      let self = this
      this.mgr.getIdToken().then(
        tokenId => {
          self.logToken(tokenId)
        },
        err => {
          console.log(err)
      })
    },
    getTokenSessionState(){
      let self = this
      this.mgr.getSessionState().then(
        sessionState => {
          self.logToken(sessionState)
        },
        err => {
          console.log(err)
      })
    },
    getAccessToken(){
      let self = this
      this.mgr.getAccessToken().then(
        acessToken => {
          self.logToken(acessToken)
        },
        err => {
          console.log(err)
      })
    },
    getTokenScopes(){
      let self = this
      this.mgr.getScopes().then(
        scopes => {
          self.logToken(scopes)
        },
        err => {
          console.log(err)
      })
    },
    getTokenProfile(){
      let self = this
      this.mgr.getProfile().then(
        tokenProfile => {
          self.logToken(tokenProfile)
        },
        err => {
          console.log(err)
      })
    },
    renewToken(){
      let self = this
      this.mgr.renewToken().then(
        newToken => {
          self.logToken(newToken)
        },
        err => {
          console.log(err)
      })
    },
    logApi(){
      document.getElementById('resultsApi').innerText = ''

      Array.prototype.forEach.call(arguments, function (msg) {
        if (msg instanceof Error) {
          msg = 'Error: ' + msg.message
        } else if (typeof msg !== 'string') {
          msg = JSON.stringify(msg, null, 2)
        }
        document.getElementById('resultsApi').innerHTML += msg + '\r\n'
      })
    },
    logToken(){
      document.getElementById('resultsToken').innerText = ''
      this.tokenResponse = ''

      Array.prototype.forEach.call(arguments, function (msg) {
        if (msg instanceof Error) {
          msg = 'Error: ' + msg.message
        } else if (typeof msg !== 'string') {
          msg = JSON.stringify(msg, null, 2)
        }
        document.getElementById('resultsToken').innerHTML += msg + '\r\n'
        this.tokenResponse = msg
      }.bind(this))

    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.auth {
  background-color: rgba(0,0,0,0.9);
  padding: 1em;
  margin: 1em;
  border-radius: 5px;
}

.btn-group button {
  background-color: var(--global-color-primary);
  border: 1px solid var(--global-color-primary);
  color: white; /* White text */
  padding: 10px 24px; /* Some padding */
  cursor: pointer; /* Pointer/hand icon */
  float: left; /* Float the buttons side by side */
}

/* Clear floats (clearfix hack) */
.btn-group:after {
  content: "";
  clear: both;
  display: table;
}

.btn-group button:not(:last-child) {
  border-right: none; /* Prevent double borders */
}

pre {
  white-space: pre-wrap;
}

/* Add a background color on hover */
.btn-group button:hover {
  background-color: var(--global-color-background-light);
  color: var(--global-color-primary);
}

</style>
